<template>
  <div>
    <!-- Review Actions -->
    <ifac-search-dropdown
      v-if="review.can.viewAllReviews"
      scope="button"
      class="m-0 mb-4"
      :current="currentReview"
      currentType="object"
      currentValue="name"
      :options="submittedReviews"
      placeholder="Consult other reviews"
      @selected="handleReview"
    ></ifac-search-dropdown>

    <!-- Review Form -->
    <div v-if="review && review.can.view">
      <div class="bg-grey-blue p-3 rounded" v-if="!isLoading && review.can.view">
        <FormulateForm v-model="formValues" :errors="formErrors">
          <ifac-review-form :review="review"
                            :form-disabled="review.can.update === false"
                            :schema="formSchema"/>
        </FormulateForm>
      </div>

      <div class="my-2" v-if="review.can.declareConflict && review.conflict_of_interest">
        You cannot fill out the review form because you have declared a conflict of interest.
      </div>

      <div class="row submit-buttons">
        <div class="col text-right right-col p-0">
          <button
            v-if="isSaveVisible"
            type="submit"
            class="btn btn-secondary"
            :disabled="this.review.can.update === false"
            @click="mx_update"
          >
            Save
          </button>
          <button
            v-if="isSubmitVisible"
            type="submit"
            class="btn btn-primary"
            :disabled="review.can.submit === false"
            @click="mx_submit"
          >
            <span v-if="review.isSubmitted">Review submitted</span>
            <span v-else>Submit review</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reviewsMixin from '@/mixins/awards/reviews.mixin';
import { IfacSearchDropdown, IfacReviewForm } from '@ifac/ui';
import { mapState } from 'vuex';

export default {
  name: 'EditReview',
  components: {
    IfacSearchDropdown,
    IfacReviewForm,
  },
  mixins: [reviewsMixin],
  props: {
    review: {
      type: Object,
      required: true,
    },
    reviews: Array,
    isLoading: {
      type: Boolean,
    },
  },
  async created() {
    this.initForm();
  },
  data() {
    return {
      formSchema: [],
      formValues: {},
      formErrors: {},
      formReport: {
        schema: [],
        values: {},
        errors: {},
      },
    };
  },
  methods: {
    initForm() {
      if (this.review) {
        this.formSchema = this.review.form_schema;
        this.formValues = this.review.form_values ?? {};
        this.formErrors = {};
      }

      if (this.report) {
        this.formReport.schema = this.report.form_schema;
        this.formReport.values = this.report.form_values ?? {};
        this.formReport.errors = {};
      }
    },
    handleReview(item) {
      if (item) {
        this.$router.push({
          name: 'ReviewsEdit',
          params: {
            review: item.id,
          },
          query: { section: 'nomination_reviews' },
        }).catch(() => ''); // avoid NavigationDuplicate error
      }
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    currentReview() {
      return this.submittedReviews.find((r) => r.id === this.review.id);
    },
    submittedReviews() {
      return this.reviews
        .filter((review) => review.isSubmitted || review.affiliate_id === this.user.id)
        .map((review) => {
        let name = review.affiliate?.name ?? 'unknown';

        if (review.affiliate_id === this.user.id) {
          name += ' (my review)';
        }

        return {
          id: review.id,
          name,
        };
      });
    },
    isSaveVisible() {
      return this.review.can.update || this.review.affiliate_id === this.user.id;
    },
    isSubmitVisible() {
      return this.review.affiliate_id === this.user.id;
    },
  },
  watch: {
    review() {
      this.initForm();
    },
  },
};
</script>
